module.exports = __webpack_public_path__ + "img/icon-chat-tips.1b6007a5.png";